import { Button, createStyles, Grid, makeStyles, styled, Typography } from '@material-ui/core';
import { COLORS } from 'shared/constants/COLORS';
const {
  DARK_TEXTBOX_BACKGROUND,
  PLAIN_TEXT,
  DARK_FIELDS_ON_CARD_MENU,
  LIGHT_MENUITEM_BACKGROUND,
  PLAIN_ICON,
  DARK_TEXT,
  DARKER_ICON,
} = COLORS;

export const Content = styled(Grid)({
  margin: '20px 0',
  '& > div:not(:last-child)': {
    marginBottom: 20,
  },
  '& .MuiOutlinedInput-root': {
    height: '50px!important',
    fontSize: 14,
    background: DARK_TEXTBOX_BACKGROUND,
  },

  '& .MuiFormLabel-root': {
    display: 'flex',
    justifyContent: 'space-between',
    fontSize: '13px',
    letterSpacing: '1px',
    alignItems: 'center',
    color: PLAIN_TEXT,

    '& .MuiBox-root': {
      padding: '2px 4px 1px 5px',
      border: '1px solid',
      borderRadius: '100%',
      fontSize: '12px',
    },
  },

  '& .MuiSelect-iconOutlined': {
    right: '0',
    top: '22px',
  },

  '& .MuiSelect-iconOpen': {
    top: '2px',
    right: '13px',
  },
});

export const CheckboxContainer = styled(Grid)({
  letterSpacing: 0.4,
  marginTop: 10,

  '& .MuiTypography-root': {
    fontSize: 15,
  },
});

export const CustomButton = styled(Button)({
  height: 50,
  fontSize: 16,
});

export const CustomText = styled(Typography)(({ theme, size }: any) => ({
  fontSize: size || 16,
  color: theme.palette.type === 'dark' ? PLAIN_TEXT : DARK_TEXT,
}));

export const useStyles = makeStyles((theme) =>
  createStyles({
    select: {
      backgroundColor:
        theme.palette.type === 'dark' ? `${DARK_FIELDS_ON_CARD_MENU} !important` : LIGHT_MENUITEM_BACKGROUND,
      '& .MuiSelect-icon': {
        color: (theme.palette.type === 'dark' ? PLAIN_ICON : DARKER_ICON) + '!important',
        top: 15,
        right: 12,
      },
    },
    main: {
      display: 'flex',
      alignItems: 'center',
      marginBottom: 20,
    },
  }),
);
